<div class="landing-a__top" #heroTopSection>
  <section class="landing-a__hero" appLandingReveal="landing-a__hero--visible">
    <div class="landing-a__container landing-a__hero-grid">
      <div class="landing-a__hero-copy">
        <span class="landing-a__eyebrow">{{ 'landing.landing_1.hero.eyebrow' | translate }}</span>
        <h1 class="landing-a__title">
          <span class="landing-a__title-line">{{ 'landing.landing_1.hero.title' | translate }}</span>
          <span class="landing-a__title-accent">{{ 'landing.landing_1.hero.title_accent' | translate }}</span>
        </h1>
        <p class="landing-a__subtitle">{{ 'landing.landing_1.hero.subtitle' | translate }}</p>

        <div class="landing-a__hero-actions">
          <a class="landing-a__btn landing-a__btn--primary landing-a__btn--lg" [href]="dashboardUrl()">
            {{ 'landing.landing_1.hero.cta_primary' | translate }}
          </a>
          <a
            class="landing-a__btn landing-a__btn--ghost landing-a__btn--lg"
            href="#how-it-works"
            (click)="scrollToSection('how-it-works', $event)"
          >
            {{ 'landing.landing_1.hero.cta_secondary' | translate }}
          </a>
        </div>
      </div>

      <div class="landing-a__hero-visual">
        <app-landing-dashboard-compare></app-landing-dashboard-compare>
      </div>
    </div>
  </section>
</div>
